import { Navigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';

interface SuperAdminRouteProps {
    children: React.ReactNode;
    /** Path to redirect to when access is denied. Defaults to '/admin/dashboard'. */
    redirectTo?: string;
}

/**
 * SuperAdminRoute
 * Renders children only for users with role_name === 'Super Admin'.
 * Redirects everyone else to `redirectTo` (default: '/admin/dashboard').
 *
 * Usage:
 *   <SuperAdminRoute>
 *     <RolesPermissionsPage />
 *   </SuperAdminRoute>
 */
const SuperAdminRoute = ({ children, redirectTo = '/admin/dashboard' }: SuperAdminRouteProps) => {
    const { isLoading, isSuperAdmin } = useAuth();

    // While the profile is loading, render nothing to avoid flash
    if (isLoading) return null;

    if (!isSuperAdmin) return <Navigate to={redirectTo} replace />;

    return <>{children}</>;
};

export default SuperAdminRoute;
